import { render, staticRenderFns } from "./Requests.vue?vue&type=template&id=e6ccbece&scoped=true&"
import script from "./Requests.vue?vue&type=script&setup=true&lang=ts&"
export * from "./Requests.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6ccbece",
  null
  
)

export default component.exports